export default "__VITE_ASSET__DVPhy5xJ__"